export const comments = `
  {
    id
    title
    text
    updatedAt
    user_model_rate
    user {
      full_name
      nickname
    }
    strengths
    weaknesses
    confirmed

    reply_to {
        id
        text
        title
        user {
            full_name
            nickname
      }
    }
  }
`;
export const comments_with_replies = `
  {
    id
    title
    text
    updatedAt
    user_useful
    useful_count
    user_model_rate
    user {
      full_name
      media {
          url
          alt
        }
      nickname
    }
    strengths
    weaknesses
    confirmed

    replies {
      user {
        full_name
        media {
          url
          alt
        }
        nickname
      }
      title
      text
      updatedAt
    }
}
`;

export const users_comments_model = `
  {
    id
    title
    text
    updatedAt
    user_model_rate
    user {
      full_name
    }
    strengths
    weaknesses
    useful_count
    user_useful
  

    replies {
      id
      text
      useful_count
      user_useful
    }
  }
`;

export const users_comments = `
  {
    id
    title
    text
    updatedAt
    useful_count 
    confirmed
    user_model_rate
    strengths
    weaknesses

    model {
        product {
            title
            seo {
              full_url
              }
            media {
                url
                alt
            }
            brand {
                title
                seo {
                full_url
                }
                }
        }
        blog {
            title
            media {
                url
                alt
            }
        }
    }
    
  }
`;
